import React, { useState } from 'react';
import { useNavigation } from './useNavigation';
import NotificationCenter from './NotificationCenter';

const getStyles = (theme) => {
    const isDark = theme === 'dark';
    const colors = {
        bar: isDark ? '#e0e0e0' : '#333',
        menuBg: isDark ? '#2a2a2a' : '#fff',
        menuBorder: isDark ? '#444' : '#ccc',
        itemBorder: isDark ? '#444' : '#eee',
    };

    return {
        hamburgerIcon: {
            cursor: 'pointer',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
        },
        bar: {
            width: '25px',
            height: '3px',
            backgroundColor: colors.bar,
            borderRadius: '2px',
        },
        menu: {
            position: 'absolute',
            top: '60px',
            left: '20px',
            backgroundColor: colors.menuBg,
            border: `1px solid ${colors.menuBorder}`,
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            padding: '10px 0', // Adjusted padding
            zIndex: 1000,
        },
        menuItemContainer: {
            borderBottom: `1px solid ${colors.itemBorder}`,
        }
    };
};

function HamburgerMenu({ theme }) {
    const [isOpen, setIsOpen] = useState(false);
    const { menuItems } = useNavigation(theme);
    const styles = getStyles(theme);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <NotificationCenter theme={theme} />
            <div>
                <div style={styles.hamburgerIcon} onClick={handleToggle}>
                    <div style={styles.bar}></div>
                    <div style={styles.bar}></div>
                    <div style={styles.bar}></div>
                </div>
                {isOpen && (
                    <div style={styles.menu}>
                        {Array.isArray(menuItems) && menuItems.map((item, index) => (
                            <div
                                key={item?.key || index}
                                style={index === menuItems.length - 1 ? null : styles.menuItemContainer}
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default HamburgerMenu;
